'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _service = require('./service');

var _Tarot = require('./Tarot');

var _Tarot2 = _interopRequireDefault(_Tarot);

var _saga = require('./saga');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var app = new _Tarot2.default();

exports.default = {
  start: app.start.bind(app),
  registerModule: app.registerModule.bind(app),
  serviceStore: _service.serviceStore,
  registerService: _service.registerService,
  invokeService: _service.invokeService,
  install: app.install.bind(app),
  dispatch: app.dispatch.bind(app),
  Tarot: _Tarot2.default,
  getInternalObject: app.getInternalObject.bind(app),
  effects: { put: _saga.put, call: _saga.call, race: _saga.race }
};
module.exports = exports['default'];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL21vZHVsZXMvY29yZS9pbmRleC5qcyJdLCJuYW1lcyI6WyJhcHAiLCJUYXJvdCIsInN0YXJ0IiwiYmluZCIsInJlZ2lzdGVyTW9kdWxlIiwic2VydmljZVN0b3JlIiwicmVnaXN0ZXJTZXJ2aWNlIiwiaW52b2tlU2VydmljZSIsImluc3RhbGwiLCJkaXNwYXRjaCIsImdldEludGVybmFsT2JqZWN0IiwiZWZmZWN0cyIsInB1dCIsImNhbGwiLCJyYWNlIl0sIm1hcHBpbmdzIjoiOzs7Ozs7QUFBQTs7QUFDQTs7OztBQUNBOzs7O0FBRUEsSUFBTUEsTUFBTSxJQUFJQyxlQUFKLEVBQVo7O2tCQUVlO0FBQ2JDLFNBQU9GLElBQUlFLEtBQUosQ0FBVUMsSUFBVixDQUFlSCxHQUFmLENBRE07QUFFYkksa0JBQWdCSixJQUFJSSxjQUFKLENBQW1CRCxJQUFuQixDQUF3QkgsR0FBeEIsQ0FGSDtBQUdiSyxxQ0FIYTtBQUliQywyQ0FKYTtBQUtiQyx1Q0FMYTtBQU1iQyxXQUFTUixJQUFJUSxPQUFKLENBQVlMLElBQVosQ0FBaUJILEdBQWpCLENBTkk7QUFPYlMsWUFBVVQsSUFBSVMsUUFBSixDQUFhTixJQUFiLENBQWtCSCxHQUFsQixDQVBHO0FBUWJDLHdCQVJhO0FBU2JTLHFCQUFtQlYsSUFBSVUsaUJBQUosQ0FBc0JQLElBQXRCLENBQTJCSCxHQUEzQixDQVROO0FBVWJXLFdBQVMsRUFBRUMsY0FBRixFQUFPQyxnQkFBUCxFQUFhQyxnQkFBYjtBQVZJLEMiLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyByZWdpc3RlclNlcnZpY2UsIGludm9rZVNlcnZpY2UsIHNlcnZpY2VTdG9yZSB9IGZyb20gJy4vc2VydmljZSdcbmltcG9ydCBUYXJvdCBmcm9tICcuL1Rhcm90J1xuaW1wb3J0IHsgcHV0LCBjYWxsLCByYWNlIH0gZnJvbSAnLi9zYWdhJ1xuXG5jb25zdCBhcHAgPSBuZXcgVGFyb3QoKVxuXG5leHBvcnQgZGVmYXVsdCB7XG4gIHN0YXJ0OiBhcHAuc3RhcnQuYmluZChhcHApLFxuICByZWdpc3Rlck1vZHVsZTogYXBwLnJlZ2lzdGVyTW9kdWxlLmJpbmQoYXBwKSxcbiAgc2VydmljZVN0b3JlLFxuICByZWdpc3RlclNlcnZpY2UsXG4gIGludm9rZVNlcnZpY2UsXG4gIGluc3RhbGw6IGFwcC5pbnN0YWxsLmJpbmQoYXBwKSxcbiAgZGlzcGF0Y2g6IGFwcC5kaXNwYXRjaC5iaW5kKGFwcCksXG4gIFRhcm90LFxuICBnZXRJbnRlcm5hbE9iamVjdDogYXBwLmdldEludGVybmFsT2JqZWN0LmJpbmQoYXBwKSxcbiAgZWZmZWN0czogeyBwdXQsIGNhbGwsIHJhY2UgfVxufVxuIl19